'use strict';

import { Button, Checkbox, Col, Collapse, Form, Input, Modal, Select, Tabs, Tooltip } from 'antd';
import React from 'react';
import { getCodeMirror } from './Dnd_SgiAllEditorCommon';
import { checkOnChange, datePickerOnChange, formItemLayout, getEditor, numberOnChange, selectOnChange, teOnBlur, textOnChange, updateCode } from './Dnd_SgiFormEditorCommonUtils';
import Dnd_SgiFormEditorRPSelect from './Dnd_SgiFormEditorRPSelect';
import Dnd_SgiFormEditorSCSelect from './Dnd_SgiFormEditorSCSelect';
import ObjFactory from 'rt-sd-common/sgiFactory/ObjFactory';
import SgiMainComp from 'rt-sd-comp/sgiComp/SgiMainComp';
import smProjDndConfig from 'rt-sd-common/sgiConfig/smProjDndConfig'


const FormItem = Form.Item;
const TabPane = Tabs.TabPane;
const Search = Input.Search;
const Panel = Collapse.Panel;
const Option = Select.Option;

var getFormCommAttEditor = (currentModule, type) => {
    return getEditor(currentModule, type);
}
var getCommAttEditor = (currentModule, type) => {
    return getEditor(currentModule, type);
}

var getSCEditor = (currentModule, label, attname) => {//标准代码
    label = label || "标准代码";
    attname = attname || "scId";
    return (
        <Col span={8}>
            <FormItem {...formItemLayout} label={label}>
                <Search value={currentModule.state.values[attname]}
                    placeholder={"请选择" + label}
                    onChange={textOnChange.bind(this, currentModule, attname)}
                    onSearch={() => currentModule.setState({ SCModalVisible: true })} />
            </FormItem>
        </Col>
    );
}
var getDSDEditor = (currentModule, label, attname) => {//标准代码
    label = label || "绑定DSD";
    attname = attname || "dsdId";
    let value = currentModule.state.values[attname];
    // let onSearch = (e) => {
    //     let guid = sgiConfig.DSDChooseUI || "rtsd_UI_DSD_2001";
    //     tool.popUI(guid, new ObjFactory(guid, { currentModule }));
    // };
    let onClick = (guid, e) => {
        window.setProOnlyUuid()
        window.open((sgiConfig.DSDUI2 || "/main/DSDUI2") + "?dsdId=" + guid);
    };
    return (
        <Col span={8}>
            <FormItem {...formItemLayout} label={label} style={{ display: "flex" }}>
                <div style={{ display: "flex" }}>
                    <Search value={value}
                        placeholder={"-请选择-"}
                        onChange={textOnChange.bind(this, currentModule, attname)}
                        onSearch={() => currentModule.setState({ DSDModalVisible: true })}
                    // onSearch={onSearch}
                    />
                    <Tooltip title="点击跳转至DSD编辑页面">
                        <Button icon="link" style={{ marginLeft: 5 }} onClick={onClick.bind(this, value)} />
                    </Tooltip>
                </div>
            </FormItem>
        </Col>
    );
}

var getSCModal = (currentModule, attname) => {
    attname = attname || "scId";
    return (
        <Modal
            title='选择标准代码（双击选择）'
            visible={currentModule.state.SCModalVisible}
            onCancel={() => currentModule.setState({ SCModalVisible: false })}
            width='1000px'
            height='800px'
            footer={null}
        >
            <Dnd_SgiFormEditorSCSelect parentModule={currentModule} attname={attname} />
        </Modal>
    );
}
var getDSDModal = (currentModule, attname) => {
    // let guid = sgiConfig.DSDChooseUI || "rtsd_UI_DSD_2001";
    let guid = sgiConfig.DSDChooseUI || smProjDndConfig.getDSDSelectGuid();
    let moduleDesc = PrmFactory.getPrm(guid);
    attname = attname || "bdDvId";
    return (
        <Modal
            title={moduleDesc ? moduleDesc.te || '选择DSD（双击选择）' : '选择DSD（双击选择）'}
            visible={currentModule.state.DSDModalVisible}
            onCancel={() => currentModule.setState({ DSDModalVisible: false })}
            width={'80%'}
            height={800}
            footer={null}
        >
            {(moduleDesc && moduleDesc.guid)
                ? <SgiMainComp
                    // ref={'Dnd_SgiMainComp_SgiMainComp'}
                    objFct={new ObjFactory(guid, { currentModule, attname, tt: "DSD", visibleKey: "DSDModalVisible" })}
                    type={currentModule.props.type}
                    dndDispatchObject={currentModule.props.dndDispatchObject}
                    moduleDesc={moduleDesc} />
                : <Dnd_SgiFormEditorSCSelect parentModule={currentModule} attname={attname} tt="DSD" visibleKey="DSDModalVisible" />}

        </Modal>
    );
}

var getRPEditor = (currentModule, label, attname) => {//资源代码
    label = label || "资源代码";
    return (
        <Col span={8}>
            <FormItem {...formItemLayout} label={label}>
                <Search value={currentModule.state.values[attname]} onChange={textOnChange.bind(this, currentModule, attname)}
                    onSearch={() => currentModule.setState({ RPModalVisible: true })} />
            </FormItem>
        </Col>
    );
}

var getRPModal = (currentModule, type, attname) => {
    return (
        <Modal
            title='选择资源代码（双击选择）'
            visible={currentModule.state.RPModalVisible}
            onCancel={() => currentModule.setState({ RPModalVisible: false })}
            width='1000px'
            height='800px'
            footer={null}
        >
            <Dnd_SgiFormEditorRPSelect parentModule={currentModule} type={type} attname={attname} />
        </Modal>
    );
}

var getStyleEditor = (currentModule) => {
    return (
        <div >
            <div>function("module", "objFct")</div>
            <div>form子组件示例：return {"{ formItemStyle: { background: \"#eeeeee\" }, inputStyle: { border: \"2px solid red\" } }"}</div>
            <div>普通组件示例：return {"{ background: \"#eeeeee\" }"}</div>
            {getCodeMirror(currentModule.state.values.cstmStyle, updateCode.bind(this, currentModule, 'cstmStyle'), currentModule.props.values.dnd_id)}
        </div>
    );
}

var getRenderEditor = (currentModule) => {
    return (
        <div >
            <div>function(module,inputprops,value,objFct)</div>
            <span>请返回自定义组件，例：return tool.createElement("a", props, children, customModuleFlg);</span>
            <div>props：组件属性；children：子组件数组；customModuleFlg：是否是自定义组件，如果是html组件该参数不填</div>
            {/* <div style={{ color: "red" }}>注意：如无返回组件，请不要输入任何内容！</div> */}
            {getCodeMirror(currentModule.state.values.cstmRender, updateCode.bind(currentModule, currentModule, 'cstmRender'), currentModule.state.values.dnd_id + "cstmRender")}
        </div>
    );
}

var getValidEditor = (currentModule) => {
    return (
        <div >
            <Checkbox style={{ marginLeft: 60, marginBottom: 10 }}
                checked={currentModule.state.values["showCheck"]} onChange={checkOnChange.bind(currentModule, currentModule, "showCheck")}>
                校验成功显示对号
                </Checkbox>
            <div>function(module,objFct,value)</div>
            <span>基础用法：如校验失败，请返回失败信息；校验成功请返回空。例：'if (value === "12") return "不能输入12"'</span>
            <div style={{ color: "peru" }}>高级用法：可返回自定义校验对象，例：'return {'{help:"请输入数字和字母的组合", validateStatus:"warning", hasFeedback:true}'}'</div>
            <div style={{ color: "peru" }}>注：help为提示信息，validateStatus为校验状态(可选 'success', 'warning', 'error', 'validating')，hasFeedback为是否显示校验结果图标，
                <a href="https://ant.design/components/form-cn/#components-form-demo-validate-static" target="_blank"
                    style={{ textDecoration: "underline", fontStyle: "italic" }}>详情></a>
            </div>
            {getCodeMirror(currentModule.state.values.cstmValid, updateCode.bind(currentModule, currentModule, 'cstmValid'), currentModule.state.values.dnd_id + "cstmValid")}
        </div>
    );
}

var getFunEditor = (currentModule, others) => {
    let moduleType = currentModule.props._name || currentModule.props.currentCtl.props.modal_context;
    let chngTip;
    switch (moduleType) {
        case "Dnd_SgiFormFileEditor": // 文件上传
            chngTip = <div>function("module", "objFct", "record", "nv", "file", "response", "fileList")</div>
            break;
        case "Dnd_SgiFormCodeMirrorEditor": // codemirror
            chngTip = <div>function("module", "objFct", "record", "nv", "data", "editor")</div>
            break;
        default:
            chngTip = <div>function("module", "objFct", "record", "nv", "nt", "itemData", "extra")</div>
            break;
    }
    return (
        <Collapse defaultActiveKey={['2']} accordion>
            <Panel header="进入事件" key="1">
                <div>function("module", "objFct")</div>
                {getCodeMirror(currentModule.state.values.inLsn, updateCode.bind(this, currentModule, 'inLsn'), currentModule.props.values.dnd_id)}
            </Panel>
            <Panel header="修改事件" key="2">
                {chngTip}
                {getCodeMirror(currentModule.state.values.chgLsn, updateCode.bind(this, currentModule, 'chgLsn'), currentModule.props.values.dnd_id)}
            </Panel>
            <Panel header="离开事件" key="3">
                <div>function("module", "objFct")</div>
                {getCodeMirror(currentModule.state.values.lveLsn, updateCode.bind(this, currentModule, 'lveLsn'), currentModule.props.values.dnd_id)}
            </Panel>
            {others}
        </Collapse>
    );
}

var getShowEditor = (currentModule, attEditor, funEditor, others) => {
    let showType = currentModule.props.showType;
    let tabPaneStyle = { height: "100%", overflow: "auto" };
    if (checkShowType("1")) attEditor = attEditor || getCommAttEditor(currentModule, currentModule.props._name || currentModule.props.currentCtl.props.modal_context);
    if (checkShowType("2")) funEditor = funEditor || getFunEditor(currentModule);
    return (
        <Tabs defaultActiveKey="1" tabBarGutter={0} style={{ height: "100%" }}>
            {checkShowType("1") ? <TabPane style={tabPaneStyle} tab="属性编辑" key="1">{attEditor}</TabPane> : null}
            {checkShowType("2") ? <TabPane style={tabPaneStyle} tab="绑定事件" key="2">{funEditor}</TabPane> : null}
            {checkShowType("3") ? <TabPane style={tabPaneStyle} tab="自定义显示样式" key="3">{getStyleEditor(currentModule)}</TabPane> : null}
            {checkShowType("4") ? <TabPane style={tabPaneStyle} tab="自定义渲染组件" key="4">{getRenderEditor(currentModule)}</TabPane> : null}
            {checkShowType("5") ? <TabPane style={tabPaneStyle} tab="自定义校验规则" key="5">{getValidEditor(currentModule)}</TabPane> : null}
            {checkShowType("0") ? others : null}
        </Tabs>
    );
    function checkShowType(num) {
        return !showType || showType.indexOf(num) > -1 || showType.indexOf(parseInt(num)) > -1
    }
}

var getSelectOptions = (scId) => {
    if (!scId) return [];
    let scs = StandardCode.getSC(scId) || [];
    return scs.map(sc => <Option value={sc.c}>{sc.te}</Option>);
}

export { getFormCommAttEditor, getCommAttEditor, getFunEditor, getShowEditor, getSCEditor, getSCModal, getRPEditor, getRPModal, getSelectOptions, getDSDModal, getDSDEditor, formItemLayout, textOnChange, numberOnChange, selectOnChange, checkOnChange, updateCode, teOnBlur, datePickerOnChange };



// WEBPACK FOOTER //
// ./~/rt-sd-dnd/sgiDndDev/Dnd_SgiFormEditorCommon.js